// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.americana-details-wrapper {
    width: 100%;
    min-height: calc(100vh - 70px);
    background-color: var(--bg-app, #F8FAFC);
    padding: 30px 20px;
    display: flex;
    justify-content: center;
}

.americana-details-container {
    width: 100%;
    max-width: 1200px;
    display: flex;
    flex-direction: column;
    gap: 30px;
}

.loading-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 50vh;
    color: var(--brand-primary);
    gap: 16px;
}

.spinner {
    width: 40px;
    height: 40px;
    border: 4px solid rgba(15, 23, 42, 0.1);
    border-top-color: var(--brand-accent);
    border-radius: 50%;
    animation: spin 1s linear infinite;
}

@keyframes spin { to { transform: rotate(360deg); } }

.error-banner {
    background-color: #FEF2F2;
    border: 1px solid #FECACA;
    color: var(--error);
    padding: 16px;
    border-radius: var(--radius-md);
    text-align: center;
    margin: 20px auto;
    max-width: 600px;
}

.americana-header {
    background: linear-gradient(135deg, var(--brand-primary) 0%, #1e293b 100%);
    color: white;
    border-radius: var(--radius-lg);
    box-shadow: var(--shadow-card);
    padding: 40px 30px;
    position: relative;
    display: flex;
    flex-direction: column;
    gap: 24px;
    overflow: hidden;
    text-align: center;
}

.americana-header::before {
    content: '';
    position: absolute;
    top: -50px;
    left: -50px;
    width: 200px;
    height: 200px;
    background: rgba(255, 255, 255, 0.05);
    border-radius: 50%;
    pointer-events: none;
}

.americana-header::after {
    content: '';
    position: absolute;
    bottom: -30px;
    right: -30px;
    width: 150px;
    height: 150px;
    background: rgba(210, 248, 0, 0.05);
    border-radius: 50%;
    pointer-events: none;
}

.header-actions {
    position: absolute;
    top: 20px;
    right: 20px;
    display: flex;
    gap: 10px;
    z-index: 10;
}

.icon-btn {
    width: 36px;
    height: 36px;
    border-radius: 50%;
    border: none;
    background: rgba(255, 255, 255, 0.15);
    color: white;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background 0.2s;
    backdrop-filter: blur(4px);
}

.icon-btn:hover {
    background: rgba(255, 255, 255, 0.3);
}

.icon-btn.delete:hover {
    background: #EF4444;
    color: white;
}

.header-content {
    position: relative;
    z-index: 2;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;
}

.americana-subtitle {
    text-transform: uppercase;
    font-size: 0.8rem;
    font-weight: 700;
    color: var(--brand-accent);
    letter-spacing: 2px;
    margin: 0;
    opacity: 0.9;
}

.americana-title {
    font-size: 2.5rem;
    font-weight: 800;
    color: white;
    margin: 0;
    line-height: 1.2;
    text-shadow: 0 2px 10px rgba(0,0,0,0.2);
}

.meta-row {
    display: flex;
    justify-content: center;
    gap: 16px;
    flex-wrap: wrap;
    margin-top: 8px;
}

.meta-item {
    background: rgba(255, 255, 255, 0.1);
    backdrop-filter: blur(4px);
    border: 1px solid rgba(255, 255, 255, 0.2);
    padding: 8px 16px;
    border-radius: 20px;
    color: rgba(255, 255, 255, 0.9);
    font-size: 0.95rem;
    font-weight: 500;
    display: flex;
    align-items: center;
    gap: 8px;
}

.meta-item i {
    color: var(--brand-accent);
}

.summary-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
    gap: 16px;
    width: 100%;
    max-width: 600px;
    margin-top: 24px;
}

.stat-card {
    background-color: rgba(0, 0, 0, 0.2);
    padding: 16px;
    border-radius: var(--radius-md);
    text-align: center;
    border: 1px solid rgba(255, 255, 255, 0.1);
    backdrop-filter: blur(4px);
}

.stat-label {
    font-size: 0.75rem;
    color: rgba(255, 255, 255, 0.7);
    text-transform: uppercase;
    font-weight: 600;
    display: block;
    margin-bottom: 6px;
    letter-spacing: 0.5px;
}

.stat-value {
    font-size: 1.75rem;
    font-weight: 800;
    color: white;
    display: block;
    line-height: 1;
}

.stat-card.highlight {
    background-color: rgba(210, 248, 0, 0.15);
    border-color: rgba(210, 248, 0, 0.3);
}

.stat-card.highlight .stat-value {
    color: var(--brand-accent);
}

.sections-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
    gap: 24px;
}

.content-card {
    background-color: var(--bg-card);
    border-radius: var(--radius-lg);
    box-shadow: var(--shadow-sm);
    padding: 24px;
    border: 1px solid var(--border-light);
    display: flex;
    flex-direction: column;
    gap: 20px;
}

.card-header h2 {
    font-size: 1.25rem;
    font-weight: 700;
    margin: 0 0 4px 0;
    color: var(--brand-primary);
}

.card-header p {
    margin: 0;
    font-size: 0.9rem;
    color: var(--text-muted);
}

.status-block {
    margin-bottom: 24px;
}

.status-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;
}

.status-header h3 {
    font-size: 1rem;
    font-weight: 600;
    margin: 0;
    color: var(--text-main);
}

.badge-count {
    background: var(--bg-app);
    padding: 2px 8px;
    border-radius: 12px;
    font-size: 0.8rem;
    font-weight: 700;
    color: var(--text-secondary);
}

.players-list {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.player-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 14px;
    background-color: var(--bg-app);
    border-radius: 8px;
    font-size: 0.95rem;
    transition: background-color 0.2s;
}

.player-row:hover {
    background-color: #F1F5F9;
}

.remove-btn-small {
    background: none;
    border: none;
    color: #EF4444;
    cursor: pointer;
    font-size: 0.85rem;
    opacity: 0.6;
    transition: opacity 0.2s;
    padding: 4px;
}

.remove-btn-small:hover {
    opacity: 1;
}

.pairs-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
    gap: 16px;
}

.court-box {
    background: var(--bg-app);
    border: 1px solid var(--border-light);
    border-radius: var(--radius-md);
    padding: 16px;
}

.court-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;
    font-weight: 700;
    color: var(--brand-primary);
}

.pair-item {
    background: white;
    padding: 8px 12px;
    border-radius: 6px;
    margin-bottom: 8px;
    font-size: 0.9rem;
    box-shadow: 0 1px 2px rgba(0,0,0,0.05);
    display: flex;
    align-items: center;
    gap: 6px;
}

.vs-divider {
    color: var(--brand-accent);
    font-weight: 800;
}

.modal-backdrop {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,0.5);
    backdrop-filter: blur(4px);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 2000;
    animation: fadeIn 0.2s ease-out;
}

.modal-content {
    background: white;
    padding: 30px;
    border-radius: var(--radius-lg);
    width: 90%;
    max-width: 400px;
    box-shadow: var(--shadow-card);
    text-align: center;
    border: 1px solid rgba(0,0,0,0.1);
}

.modal-title {
    font-size: 1.25rem;
    font-weight: 700;
    margin-bottom: 12px;
    color: var(--brand-primary);
}

.modal-text {
    color: var(--text-muted);
    margin-bottom: 24px;
    line-height: 1.5;
}

.modal-actions {
    display: flex;
    gap: 12px;
    justify-content: center;
}

.btn-modal {
    padding: 10px 20px;
    border-radius: 8px;
    font-weight: 600;
    cursor: pointer;
    border: none;
    font-size: 0.95rem;
    transition: transform 0.1s;
}

.btn-modal.cancel {
    background: var(--bg-app);
    color: var(--text-main);
}

.btn-modal.danger {
    background: #EF4444;
    color: white;
    box-shadow: 0 4px 10px rgba(239, 68, 68, 0.3);
}

@keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }

@media (max-width: 768px) {
    .americana-details-wrapper {
        padding: 16px;
    }
    .americana-title {
        font-size: 1.8rem;
    }
    .sections-grid {
        grid-template-columns: 1fr;
    }
}

@media (max-width: 600px) {
    .americana-header {
        padding: 30px 20px;
    }
    .meta-row {
        flex-direction: column;
        width: 100%;
    }
    .meta-item {
        width: 100%;
        justify-content: center;
    }
}
`, "",{"version":3,"sources":["webpack://./src/pages/AmericanaDetails.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,8BAA8B;IAC9B,wCAAwC;IACxC,kBAAkB;IAClB,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,2BAA2B;IAC3B,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,uCAAuC;IACvC,qCAAqC;IACrC,kBAAkB;IAClB,kCAAkC;AACtC;;AAEA,kBAAkB,KAAK,yBAAyB,EAAE,EAAE;;AAEpD;IACI,yBAAyB;IACzB,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;IACb,+BAA+B;IAC/B,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,0EAA0E;IAC1E,YAAY;IACZ,+BAA+B;IAC/B,8BAA8B;IAC9B,kBAAkB;IAClB,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,YAAY;IACZ,aAAa;IACb,qCAAqC;IACrC,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,aAAa;IACb,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,mCAAmC;IACnC,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,aAAa;IACb,SAAS;IACT,WAAW;AACf;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,qCAAqC;IACrC,YAAY;IACZ,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,2BAA2B;IAC3B,0BAA0B;AAC9B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,yBAAyB;IACzB,iBAAiB;IACjB,gBAAgB;IAChB,0BAA0B;IAC1B,mBAAmB;IACnB,SAAS;IACT,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;IACZ,SAAS;IACT,gBAAgB;IAChB,uCAAuC;AAC3C;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,oCAAoC;IACpC,0BAA0B;IAC1B,0CAA0C;IAC1C,iBAAiB;IACjB,mBAAmB;IACnB,+BAA+B;IAC/B,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,2DAA2D;IAC3D,SAAS;IACT,WAAW;IACX,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,oCAAoC;IACpC,aAAa;IACb,+BAA+B;IAC/B,kBAAkB;IAClB,0CAA0C;IAC1C,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;IAClB,+BAA+B;IAC/B,yBAAyB;IACzB,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;IACZ,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,yCAAyC;IACzC,oCAAoC;AACxC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,2DAA2D;IAC3D,SAAS;AACb;;AAEA;IACI,gCAAgC;IAChC,+BAA+B;IAC/B,4BAA4B;IAC5B,aAAa;IACb,qCAAqC;IACrC,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,2BAA2B;AAC/B;;AAEA;IACI,SAAS;IACT,iBAAiB;IACjB,wBAAwB;AAC5B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,SAAS;IACT,uBAAuB;AAC3B;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;IAChB,4BAA4B;AAChC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;IAClB,+BAA+B;IAC/B,kBAAkB;IAClB,kBAAkB;IAClB,iCAAiC;AACrC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,YAAY;IACZ,wBAAwB;IACxB,YAAY;AAChB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,aAAa;IACb,4DAA4D;IAC5D,SAAS;AACb;;AAEA;IACI,yBAAyB;IACzB,qCAAqC;IACrC,+BAA+B;IAC/B,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;IAChB,2BAA2B;AAC/B;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;IACjB,sCAAsC;IACtC,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,0BAA0B;IAC1B,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,2BAA2B;IAC3B,0BAA0B;IAC1B,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,+BAA+B;AACnC;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,+BAA+B;IAC/B,UAAU;IACV,gBAAgB;IAChB,8BAA8B;IAC9B,kBAAkB;IAClB,iCAAiC;AACrC;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,2BAA2B;AAC/B;;AAEA;IACI,wBAAwB;IACxB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,0BAA0B;AAC9B;;AAEA;IACI,yBAAyB;IACzB,uBAAuB;AAC3B;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,6CAA6C;AACjD;;AAEA,oBAAoB,OAAO,UAAU,EAAE,EAAE,KAAK,UAAU,EAAE,EAAE;;AAE5D;IACI;QACI,aAAa;IACjB;IACA;QACI,iBAAiB;IACrB;IACA;QACI,0BAA0B;IAC9B;AACJ;;AAEA;IACI;QACI,kBAAkB;IACtB;IACA;QACI,sBAAsB;QACtB,WAAW;IACf;IACA;QACI,WAAW;QACX,uBAAuB;IAC3B;AACJ","sourcesContent":[".americana-details-wrapper {\n    width: 100%;\n    min-height: calc(100vh - 70px);\n    background-color: var(--bg-app, #F8FAFC);\n    padding: 30px 20px;\n    display: flex;\n    justify-content: center;\n}\n\n.americana-details-container {\n    width: 100%;\n    max-width: 1200px;\n    display: flex;\n    flex-direction: column;\n    gap: 30px;\n}\n\n.loading-container {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    min-height: 50vh;\n    color: var(--brand-primary);\n    gap: 16px;\n}\n\n.spinner {\n    width: 40px;\n    height: 40px;\n    border: 4px solid rgba(15, 23, 42, 0.1);\n    border-top-color: var(--brand-accent);\n    border-radius: 50%;\n    animation: spin 1s linear infinite;\n}\n\n@keyframes spin { to { transform: rotate(360deg); } }\n\n.error-banner {\n    background-color: #FEF2F2;\n    border: 1px solid #FECACA;\n    color: var(--error);\n    padding: 16px;\n    border-radius: var(--radius-md);\n    text-align: center;\n    margin: 20px auto;\n    max-width: 600px;\n}\n\n.americana-header {\n    background: linear-gradient(135deg, var(--brand-primary) 0%, #1e293b 100%);\n    color: white;\n    border-radius: var(--radius-lg);\n    box-shadow: var(--shadow-card);\n    padding: 40px 30px;\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    gap: 24px;\n    overflow: hidden;\n    text-align: center;\n}\n\n.americana-header::before {\n    content: '';\n    position: absolute;\n    top: -50px;\n    left: -50px;\n    width: 200px;\n    height: 200px;\n    background: rgba(255, 255, 255, 0.05);\n    border-radius: 50%;\n    pointer-events: none;\n}\n\n.americana-header::after {\n    content: '';\n    position: absolute;\n    bottom: -30px;\n    right: -30px;\n    width: 150px;\n    height: 150px;\n    background: rgba(210, 248, 0, 0.05);\n    border-radius: 50%;\n    pointer-events: none;\n}\n\n.header-actions {\n    position: absolute;\n    top: 20px;\n    right: 20px;\n    display: flex;\n    gap: 10px;\n    z-index: 10;\n}\n\n.icon-btn {\n    width: 36px;\n    height: 36px;\n    border-radius: 50%;\n    border: none;\n    background: rgba(255, 255, 255, 0.15);\n    color: white;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transition: background 0.2s;\n    backdrop-filter: blur(4px);\n}\n\n.icon-btn:hover {\n    background: rgba(255, 255, 255, 0.3);\n}\n\n.icon-btn.delete:hover {\n    background: #EF4444;\n    color: white;\n}\n\n.header-content {\n    position: relative;\n    z-index: 2;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 16px;\n}\n\n.americana-subtitle {\n    text-transform: uppercase;\n    font-size: 0.8rem;\n    font-weight: 700;\n    color: var(--brand-accent);\n    letter-spacing: 2px;\n    margin: 0;\n    opacity: 0.9;\n}\n\n.americana-title {\n    font-size: 2.5rem;\n    font-weight: 800;\n    color: white;\n    margin: 0;\n    line-height: 1.2;\n    text-shadow: 0 2px 10px rgba(0,0,0,0.2);\n}\n\n.meta-row {\n    display: flex;\n    justify-content: center;\n    gap: 16px;\n    flex-wrap: wrap;\n    margin-top: 8px;\n}\n\n.meta-item {\n    background: rgba(255, 255, 255, 0.1);\n    backdrop-filter: blur(4px);\n    border: 1px solid rgba(255, 255, 255, 0.2);\n    padding: 8px 16px;\n    border-radius: 20px;\n    color: rgba(255, 255, 255, 0.9);\n    font-size: 0.95rem;\n    font-weight: 500;\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.meta-item i {\n    color: var(--brand-accent);\n}\n\n.summary-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));\n    gap: 16px;\n    width: 100%;\n    max-width: 600px;\n    margin-top: 24px;\n}\n\n.stat-card {\n    background-color: rgba(0, 0, 0, 0.2);\n    padding: 16px;\n    border-radius: var(--radius-md);\n    text-align: center;\n    border: 1px solid rgba(255, 255, 255, 0.1);\n    backdrop-filter: blur(4px);\n}\n\n.stat-label {\n    font-size: 0.75rem;\n    color: rgba(255, 255, 255, 0.7);\n    text-transform: uppercase;\n    font-weight: 600;\n    display: block;\n    margin-bottom: 6px;\n    letter-spacing: 0.5px;\n}\n\n.stat-value {\n    font-size: 1.75rem;\n    font-weight: 800;\n    color: white;\n    display: block;\n    line-height: 1;\n}\n\n.stat-card.highlight {\n    background-color: rgba(210, 248, 0, 0.15);\n    border-color: rgba(210, 248, 0, 0.3);\n}\n\n.stat-card.highlight .stat-value {\n    color: var(--brand-accent);\n}\n\n.sections-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));\n    gap: 24px;\n}\n\n.content-card {\n    background-color: var(--bg-card);\n    border-radius: var(--radius-lg);\n    box-shadow: var(--shadow-sm);\n    padding: 24px;\n    border: 1px solid var(--border-light);\n    display: flex;\n    flex-direction: column;\n    gap: 20px;\n}\n\n.card-header h2 {\n    font-size: 1.25rem;\n    font-weight: 700;\n    margin: 0 0 4px 0;\n    color: var(--brand-primary);\n}\n\n.card-header p {\n    margin: 0;\n    font-size: 0.9rem;\n    color: var(--text-muted);\n}\n\n.status-block {\n    margin-bottom: 24px;\n}\n\n.status-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 12px;\n}\n\n.status-header h3 {\n    font-size: 1rem;\n    font-weight: 600;\n    margin: 0;\n    color: var(--text-main);\n}\n\n.badge-count {\n    background: var(--bg-app);\n    padding: 2px 8px;\n    border-radius: 12px;\n    font-size: 0.8rem;\n    font-weight: 700;\n    color: var(--text-secondary);\n}\n\n.players-list {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n}\n\n.player-row {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 10px 14px;\n    background-color: var(--bg-app);\n    border-radius: 8px;\n    font-size: 0.95rem;\n    transition: background-color 0.2s;\n}\n\n.player-row:hover {\n    background-color: #F1F5F9;\n}\n\n.remove-btn-small {\n    background: none;\n    border: none;\n    color: #EF4444;\n    cursor: pointer;\n    font-size: 0.85rem;\n    opacity: 0.6;\n    transition: opacity 0.2s;\n    padding: 4px;\n}\n\n.remove-btn-small:hover {\n    opacity: 1;\n}\n\n.pairs-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));\n    gap: 16px;\n}\n\n.court-box {\n    background: var(--bg-app);\n    border: 1px solid var(--border-light);\n    border-radius: var(--radius-md);\n    padding: 16px;\n}\n\n.court-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 12px;\n    font-weight: 700;\n    color: var(--brand-primary);\n}\n\n.pair-item {\n    background: white;\n    padding: 8px 12px;\n    border-radius: 6px;\n    margin-bottom: 8px;\n    font-size: 0.9rem;\n    box-shadow: 0 1px 2px rgba(0,0,0,0.05);\n    display: flex;\n    align-items: center;\n    gap: 6px;\n}\n\n.vs-divider {\n    color: var(--brand-accent);\n    font-weight: 800;\n}\n\n.modal-backdrop {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background: rgba(0,0,0,0.5);\n    backdrop-filter: blur(4px);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 2000;\n    animation: fadeIn 0.2s ease-out;\n}\n\n.modal-content {\n    background: white;\n    padding: 30px;\n    border-radius: var(--radius-lg);\n    width: 90%;\n    max-width: 400px;\n    box-shadow: var(--shadow-card);\n    text-align: center;\n    border: 1px solid rgba(0,0,0,0.1);\n}\n\n.modal-title {\n    font-size: 1.25rem;\n    font-weight: 700;\n    margin-bottom: 12px;\n    color: var(--brand-primary);\n}\n\n.modal-text {\n    color: var(--text-muted);\n    margin-bottom: 24px;\n    line-height: 1.5;\n}\n\n.modal-actions {\n    display: flex;\n    gap: 12px;\n    justify-content: center;\n}\n\n.btn-modal {\n    padding: 10px 20px;\n    border-radius: 8px;\n    font-weight: 600;\n    cursor: pointer;\n    border: none;\n    font-size: 0.95rem;\n    transition: transform 0.1s;\n}\n\n.btn-modal.cancel {\n    background: var(--bg-app);\n    color: var(--text-main);\n}\n\n.btn-modal.danger {\n    background: #EF4444;\n    color: white;\n    box-shadow: 0 4px 10px rgba(239, 68, 68, 0.3);\n}\n\n@keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }\n\n@media (max-width: 768px) {\n    .americana-details-wrapper {\n        padding: 16px;\n    }\n    .americana-title {\n        font-size: 1.8rem;\n    }\n    .sections-grid {\n        grid-template-columns: 1fr;\n    }\n}\n\n@media (max-width: 600px) {\n    .americana-header {\n        padding: 30px 20px;\n    }\n    .meta-row {\n        flex-direction: column;\n        width: 100%;\n    }\n    .meta-item {\n        width: 100%;\n        justify-content: center;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
